import { useEffect, useRef } from "react";

import { enviarTelemetria } from "./api";

// Mede duas coisas e manda num envio só quando a aba some:
//  - tempo com o cardápio visível (TODA loja: é a linha de base do relatório);
//  - cards de oferta que realmente entraram na tela (≥50% por 600 ms), uma vez
//    por oferta por dia neste aparelho.
export function useTelemetriaCardapio({ habilitado, dia }) {
  const vistasRef = useRef(new Set());
  const tempoRef = useRef({ acumulado: 0, desde: null });
  const diaRef = useRef(dia);
  diaRef.current = dia;

  useEffect(() => {
    if (!habilitado) return undefined;
    const t = tempoRef.current;
    const iniciar = () => { if (t.desde == null) t.desde = Date.now(); };
    const pausar = () => {
      if (t.desde != null) { t.acumulado += Date.now() - t.desde; t.desde = null; }
    };
    const enviar = () => {
      pausar();
      const segundos = Math.min(Math.round(t.acumulado / 1000), 10800);
      const vistas = [...vistasRef.current].slice(0, 200);
      if (segundos < 1 && vistas.length === 0) return;
      enviarTelemetria({ dia: diaRef.current || null, vistas, segundos });
      t.acumulado = 0;
      vistasRef.current = new Set();
    };
    if (document.visibilityState === "visible") iniciar();
    const aoMudar = () => { if (document.visibilityState === "hidden") enviar(); else iniciar(); };
    document.addEventListener("visibilitychange", aoMudar);
    window.addEventListener("pagehide", enviar);
    return () => {
      document.removeEventListener("visibilitychange", aoMudar);
      window.removeEventListener("pagehide", enviar);
      enviar();
    };
  }, [habilitado]);

  useEffect(() => {
    if (!habilitado || !dia || typeof IntersectionObserver === "undefined") return undefined;
    const chaveLocal = `nucleo_ofertas_vistas_${dia}`;
    let registradas;
    try { registradas = new Set(JSON.parse(localStorage.getItem(chaveLocal) || "[]")); } catch { registradas = new Set(); }
    const timers = new Map();
    const observador = new IntersectionObserver((entradas) => {
      for (const e of entradas) {
        const chave = e.target.getAttribute("data-oferta-chave");
        if (!chave || registradas.has(chave)) continue;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          if (!timers.has(chave)) {
            timers.set(chave, setTimeout(() => {
              vistasRef.current.add(chave);
              registradas.add(chave);
              try { localStorage.setItem(chaveLocal, JSON.stringify([...registradas])); } catch { /* ok */ }
            }, 600));
          }
        } else if (timers.has(chave)) {
          clearTimeout(timers.get(chave));
          timers.delete(chave);
        }
      }
    }, { threshold: [0, 0.5] });
    let agendado = false;
    const observarCards = () => {
      agendado = false;
      document.querySelectorAll("[data-oferta-chave]").forEach((el) => observador.observe(el));
    };
    observarCards();
    const mutacoes = new MutationObserver(() => {
      if (!agendado) { agendado = true; window.requestAnimationFrame(observarCards); }
    });
    mutacoes.observe(document.body, { childList: true, subtree: true });
    return () => {
      observador.disconnect();
      mutacoes.disconnect();
      timers.forEach(clearTimeout);
    };
  }, [habilitado, dia]);
}
